import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
// import CardEmpower from "./cardEmpower";
// import seniorLiving from "../../../assets/images/senior-living.png";
// import seniorCare from "../../../assets/images/senior-care.png";
// import careGiving from "../../../assets/images/care-giving.png";
// import ageAtHome from "../../../assets/images/age-at-home.png";
// import lifeSimplePleasures from "../../../assets/images/life-simple-pleasures.png";
import { Row, Col, Container } from "reactstrap";
import { blogData } from "../../home/empowerment/blogData";
import Typography from "@mui/material/Typography";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import { useHistory } from "react-router-dom";
import "./_empowerment.scss";
import { Grid } from "@mui/material";

const Empowerment = () => {
  let history = useHistory();
  const [users, setUsers] = useState([]);
  const [filterMenu, setFilterMenu] = useState(false);
  const [filterUsers, setFilterUsers] = useState([]);

  useEffect(() => {
    setUsers(blogData);
    setFilterUsers(blogData);
  }, []);

  const filterArray = [
    { name: "A" },
    { name: "B" },
    { name: "C" },
    { name: "D" },
    { name: "E" },
    { name: "F" },
    { name: "G" },
    { name: "H" },
    { name: "I" },
    { name: "J" },
    { name: "K" },
    { name: "L" },
    { name: "M" },
    { name: "N" },
    { name: "O" },
    { name: "P" },
    { name: "Q" },
    { name: "R" },
    { name: "S" },
    { name: "T" },
    { name: "U" },
    { name: "V" },
    { name: "W" },
    { name: "X" },
    { name: "Y" },
    { name: "Z" },
  ];
  const [active, setActive] = useState(filterArray[0]);

  const alphabeticFilter = () => {
    setFilterMenu(!filterMenu);
    setActive({ name: "" });
  };
  const sortByCategory = (list) => {
    list = list.sort((a, b) => {
      return a.category.localeCompare(b.category);
    });
    return list;
  };

  return (
    <section className="empowermentTemplate">
      <Container>
        <div className="empowermentTemplate__head">
          <h1 className="empowermentTemplate__title">Our Blogs</h1>
          <Button
            onClick={() => {
              alphabeticFilter();
              setFilterUsers(users);
            }}
          >
            Menu
          </Button>
        </div>
        <Accordion
          className="search-filter"
          hidden={!filterMenu}
          defaultExpanded={filterMenu}
        >
          <AccordionDetails>
            <Typography className="filterList-title">A to Z</Typography>
            <div className="filterList-alphabet">
              {filterArray.map((filterValue, index) => {
                return (
                  <div key={index}>
                    <Button
                      className={
                        filterValue.name === active.name
                          ? "selectedAlphabet"
                          : ""
                      }
                      active={active === filterValue.name}
                      onClick={() => {
                        let data = users.filter((i) =>
                          i.category
                            .toLowerCase()
                            .startsWith(filterValue.name.toLocaleLowerCase())
                        );
                        setFilterUsers(data);
                        setActive(filterValue);
                      }}
                    >
                      {filterValue.name}
                    </Button>
                  </div>
                );
              })}
            </div>
          </AccordionDetails>
        </Accordion>
        <Grid container spacing={3}>
          {sortByCategory(filterUsers).map((item, index) => {
            return (
              <Grid item lg={4} md={6} xs={12} key={index}>
                <div className="blogCard">
                  <h4 className="blogCard__title">{item.category}</h4>
                  <div
                    className="blogCard__image"
                    onClick={() => {
                      history.push({
                        pathname: "/category-blog/" + item.id,
                        state: { item },
                      });
                    }}
                  >
                    <img src={item.image} alt="Blogs" />
                  </div>
                </div>
              </Grid>
            );
          })}
        </Grid>
        {/* <Row className="empower-list">
            <Col xs="6" sm="4">
              <CardEmpower
                src={seniorLiving}
                title="Senior Living"
                link="https://blog.mihygge.com/category/senior-living/"
              />
            </Col>
            <Col xs="6" sm="4">
              <CardEmpower
                src={seniorCare}
                title="Senior Care"
                link="https://blog.mihygge.com/category/senior-care/"
              />
            </Col>
            <Col xs="6" sm="4">
              <CardEmpower
                src={careGiving}
                title="Care Giving"
                link="https://blog.mihygge.com/category/care-giving/"
              />
            </Col>
            <Col xs="6" sm="4">
              <CardEmpower
                src={ageAtHome}
                title="Age At Home"
                link="https://blog.mihygge.com/category/age-at-home/"
              />
            </Col>
            <Col xs="12" sm="8">
              <CardEmpower
                src={lifeSimplePleasures}
                title="Life's Simple Pleasures (miHygge)"
                link="https://blog.mihygge.com/category/lifes-simple-pleasures/"
              />
            </Col>
          </Row> */}
      </Container>
    </section>
  );
};

export default Empowerment;
